@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';
@import '../../respond-to.scss';

customer-chat {
  height: 100%;
}

// Styles for CustomerChat -- Simple Header
.ghf-customerChat--simple {
  display: none;
  height: 100%;

  div.img {
    @include icon('assets/chat_grey.svg');
  }

  .ghf-customerChat {
    &-text {
      display: none;
      font-size: $typography-caption-caption-large-size;
      // Design Token doesn't match Figma
      line-height: 17px;
      letter-spacing: $typography-caption-caption-large-letter-spacing;
    }

    &-storeText {
      display: none;
      font-size: $typography-button-medium-size;
      line-height: $typography-button-medium-line-height;
      margin: 0;
      color: $color-blue-default;
      text-decoration: none;
    }

    &-liveEngage--desktop {
      display: none;
    }
  }

  @include breakpoint('md') {
    display: flex;
    align-items: center;
    gap: $spacing-8;

    .ghf-customerChat {
      &-storeText {
        display: block;
      }

      &-liveEngage {
        &--desktop {
          display: none;
        }

        &--mobile {
          display: block;
        }
      }
    }
  }

  @include breakpoint('lg') {
    display: flex;
    align-items: center;
    gap: $spacing-8;

    .ghf-customerChat {
      &-text {
        display: block;
      }

      &-storeText {
        display: block;
        color: $color-blue-default;
      }

      &-liveEngage {
        &--desktop {
          display: block;
        }

        &--mobile {
          display: none;
        }
      }
    }
  }

  @include breakpoint('xl') {
    display: flex;
    align-items: center;
    gap: $spacing-8;

    .ghf-customerChat {
      &-text {
        display: block;
      }

      &-storeText {
        display: block;
        color: $color-blue-default;
      }

      &-liveEngage {
        &--desktop {
          display: block;
        }

        &--mobile {
          display: none;
        }
      }
    }
  }

  // Styles for the LiveEngage replacement div
  #LP_DIV_RB_6687889599,
  #LP_DIV_RB_1501165477970 {
    font-size: $typography-button-medium-size;
    line-height: $typography-button-medium-line-height;
    margin: 0;
    color: $color-gray-slate-dark;
    text-decoration: none;
    cursor: pointer;
    white-space: nowrap;

    div {
      display: inline-block !important;

      @include breakpoint('lg') {
        color: $color-blue-default;
      }
      @include breakpoint('xl') {
        color: $color-blue-default;
      }
    }

    .ghf-customerChat {
      &-storeText {
        display: none;

        &:only-child {
          display: inline;
        }
      }
    }
  }
}

// Styles for CustomerChat -- Default Header
.ghf-customerChat--default {
  &--desktop {
    height: 100%;
    cursor: pointer;
    display: none;
    align-items: center;
    gap: 4px;
    white-space: nowrap;

    #LP_DIV_2023_6687889599,
    #LP_DIV_2023_1645056394123 {
      text-decoration: none;
      color: $color-shade-white;
      white-space: nowrap;

      div {
        display: inline-block !important;
        text-decoration: none;
        color: $color-shade-white;
        white-space: nowrap !important;
      }

      .ghf-customerChat {
        &-text {
          white-space: nowrap;
          display: none;
          &:only-child {
            display: inline;
          }
        }
      }
    }

    @include breakpoint('lg') {
      display: flex;
    }
    @include breakpoint('xl') {
      display: flex;
    }
  }
}
